/** In-app privacy notice (Adatkezelési tájékoztató). */
export const PRIVACY_POLICY_PATH = '/adatkezelesi-tajekoztato';
